import angular from 'angular';

import leadTimeComponent from './lead-time.component';

export default angular.module('dbm.dashboard.components.widgets.lead-time', [])
.component('dbmLeadTimeWidget', leadTimeComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/lead-time/index.js